module.exports = __webpack_public_path__ + "img/btn_color.ac11d0bc.svg";